import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import { ECreditAdjustmentReason } from '@leedpulse-monorepo/enums';
import { SubscriptionCreditsAdjustmentResponse } from './addSubscriptionCredits';

async function updateSubscriptionCredits(
  subscriptionId: string,
  leedbucks: number,
  reason: ECreditAdjustmentReason,
  comment: string | null,
  auth: Authentication
): Promise<SubscriptionCreditsAdjustmentResponse> {
  try {
    const response = await HttpClient.put(
      `/backoffice/subscriptions/${subscriptionId}/credits`,
      { leedbucks, reason, comment },
      auth.token
    );
    return response.data;
  } catch (e: any) {
    console.error('updateSubscriptionCredits error:', e);
    throw new UpdateSubscriptionCreditsFailure(e.message);
  }
}

export class UpdateSubscriptionCreditsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default updateSubscriptionCredits;